import React from "react";

export function Skel({ className = "", style }) {
  return <div className={`skel ${className}`} style={style} />;
}
